import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Header from './components/Header';
import Erro from './pages/Erro';
import Favorite from './pages/Favorite';
import Home from './pages/Home';
import Movie from './pages/Movie';

export default function RoutesApp() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/movie/:id" element={<Movie />} />
        <Route path="/favorites" element={<Favorite />} />
        <Route path="*" element={<Erro />} />
      </Routes>
    </BrowserRouter>
  );
}
